export default __webpack_public_path__ + "static/media/io.489321d5.gif";